import debugConfig from 'src/config/debugConfig';
import WebServiceApiFactory from 'src/config/WebServiceApiFactory';

const api = WebServiceApiFactory.create(debugConfig.environment);
export default api;
